export const TEST_SHACK_REPORT_STATUS = {
	IN: "In",
	GO: "Go",
	NO_GO: "NoGo",
	OVER: "Over",
	UNDER: "Under",
	NO_SPEC: "NoSpec",
} as const;

export type TestShackReportStatus =
	(typeof TEST_SHACK_REPORT_STATUS)[keyof typeof TEST_SHACK_REPORT_STATUS];

export interface TestShackReportInspectionSummary {
	ProfileInspectionId: number;
	AssetId: number;
	SectionId: number;
	SectionName: string;
	ProfileSpecId: number;
	SpecRev: number | null;
	SpecSubRev: number | null;
	MillDrawingUploadFileId: number | null;
	DimensionsReferenceUploadFileId: number | null;
	ShiftId: number;
	ProductionDate: Date;
	ProductionShift: number;
	Shift: string | null;
	Crew: string | null;
	ShiftStart: Date;
	ShiftEnd: Date;
	EventId: number | null;
	EventStart: Date | null;
	EventEnd: Date | null;
	InspectedAt: Date;
	HeatId: number | null;
	HeatName: string | null;
	Inspector: string | null;
	MeasuredLbsPerFoot: number | null;
	TargetLbsPerFoot: number | null;
	MinLbsPerFoot: number | null;
	MaxLbsPerFoot: number | null;
	WeightStatus: TestShackReportStatus | null;
	MeasuredItemCount: number;
	OutOfSpecCount: number;
	Comments: string | null;
}

export interface TestShackReportItem {
	ProfileInspectionId: number;
	ProfileSpecId: number;
	ProfileItemId: number;
	ProfileCategoryId: number;
	CategoryName: string;
	CategorySortOrder: number;
	Code: string;
	Name: string;
	DisplayName: string | null;
	ValueTypeCode: string;
	SortOrder: number;
	NumericValue: number | null;
	Checked: boolean | null;
	IsDegrees: boolean;
	Ltl: number | null;
	Nominal: number | null;
	Utl: number | null;
	Status: TestShackReportStatus;
}

export interface TestShackReportLegDelta {
	ProfileInspectionId: number;
	DeltaCode: string;
	SortOrder: number;
	Value: number | null;
	LegDeltaMax: number | null;
	Status: TestShackReportStatus;
}

export interface TestShackReportInspection
	extends TestShackReportInspectionSummary {
	items: TestShackReportItem[];
	legDeltas: TestShackReportLegDelta[];
}

export interface TestShackReport {
	inspections: TestShackReportInspection[];
}

export interface TestShackReportSectionOption {
	SectionId: number;
	SectionName: string;
}

export interface TestShackReportEventOption {
	EventId: number;
	SectionId: number;
	SectionName: string;
	Start: Date | null;
	End: Date | null;
}

export interface TestShackReportHeatOption {
	HeatId: number;
	HeatName: string;
}

export interface TestShackReportFilterOptions {
	sections: TestShackReportSectionOption[];
	events: TestShackReportEventOption[];
	heats: TestShackReportHeatOption[];
}

export interface TestShackReportRequest {
	assetId: number;
	startDate: Date | null;
	endDate: Date | null;
	shiftId: number | null;
	sectionId: number | null;
	eventId: number | null;
	heatId: number | null;
	problemsOnly: boolean;
}

export interface TestShackReportFiltersRequest {
	assetId: number;
	startDate: Date | null;
	endDate: Date | null;
	shiftId: number | null;
	sectionId: number | null;
	eventId: number | null;
}
